"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateQueryParams;
var _utils = require("../../middleware/utils");
function generateQueryParams(values) {
  var beneficiaryMap = {
    'my spouse': 'spouse',
    'not my spouse': 'not_spouse'
  };
  var rateOfReturnMap = {
    '0%': 0,
    '1%': 1,
    '2%': 2,
    '3%': 3,
    '4%': 4,
    '5%': 5,
    '6%': 6,
    '7%': 7,
    '8%': 8,
    '9%': 9,
    '10%': 10
  };
  var spouseBirthDay, spouseBirthMonth, spouseBirthYear;
  if (values.beneficiary == 'not my spouse') {
    spouseBirthDay = (0, _utils.parseCurrencyString)(null, values.birthDay);
    spouseBirthMonth = (0, _utils.parseCurrencyString)(null, values.birthMonth);
    spouseBirthYear = (0, _utils.parseCurrencyString)(null, values.birthYear);
  } else {
    spouseBirthDay = (0, _utils.parseCurrencyString)(null, values.spouseBirthDay);
    spouseBirthMonth = (0, _utils.parseCurrencyString)(null, values.spouseBirthMonth);
    spouseBirthYear = (0, _utils.parseCurrencyString)(null, values.spouseBirthYear);
  }
  var queryParams = '?';
  queryParams += 'account_balance=' + (0, _utils.parseCurrencyString)(null, values.accountBalance) + '&';
  queryParams += 'rate_of_return=' + rateOfReturnMap[values.rateOfReturn] + '&';
  queryParams += 'beneficiary_type=' + beneficiaryMap[values.beneficiary] + '&';
  queryParams += 'retiree_birth_date_day=' + (0, _utils.parseCurrencyString)(null, values.birthDay) + '&';
  queryParams += 'retiree_birth_date_month=' + (0, _utils.parseCurrencyString)(null, values.birthMonth) + '&';
  queryParams += 'retiree_birth_date_year=' + (0, _utils.parseCurrencyString)(null, values.birthYear) + '&';
  queryParams += 'spouse_birth_date_day=' + (0, _utils.parseCurrencyString)(null, spouseBirthDay) + '&';
  queryParams += 'spouse_birth_date_month=' + (0, _utils.parseCurrencyString)(null, spouseBirthMonth) + '&';
  queryParams += 'spouse_birth_date_year=' + (0, _utils.parseCurrencyString)(null, spouseBirthYear);
  return queryParams;
}